<script setup>
import {ref} from "vue";
import marketSubSectorsService from "@/services/market-sub-sectors.service";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";

const showModal = ref(false);
const subsectorId = ref(0);
const focusAreas = ref([]);
const syncing = ref(false);

async function getData() {
    const {data} = await marketSubSectorsService.getFocusAreas(subsectorId.value);
    focusAreas.value = data;
}

async function resync() {
    syncing.value = true;
    await marketSubSectorsService.resyncFocusAreas(subsectorId.value);

    syncing.value = false;
    getData();
}

function open(id) {
    focusAreas.value = [];
    subsectorId.value = id;
    showModal.value = true;
    getData();
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Focus Areas">
        <ul>
            <li v-for="area in focusAreas" :key="area" class="mt-2">
                {{ area }}
            </li>
        </ul>

        <template #modal-footer>
            <PrimaryButton
                :loading="syncing"
                caption="Re-Sync"
                loading-caption="Syncing..."
                @click="resync"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
